import React from "react";
import { default as ManageFormParent } from "./ManageForms";

function ManageForms() {
  return <ManageFormParent />;
}

export default ManageForms;
